import { render, staticRenderFns } from "./DeleteSensorWarning.vue?vue&type=template&id=c5852146"
import script from "./DeleteSensorWarning.vue?vue&type=script&lang=js"
export * from "./DeleteSensorWarning.vue?vue&type=script&lang=js"
import style0 from "./DeleteSensorWarning.vue?vue&type=style&index=0&id=c5852146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports